// document.querySelector('.select').setCustomValidity('Invalid');
// 检查 jQuery 是否已加载
if (typeof jQuery === 'undefined') {
    // 如果未加载，则动态加载 jQuery
    var script = document.createElement('script');
    script.src = 'https://code.jquery.com/jquery-3.7.1.min.js';
    script.onload = function() {
      $('.condition-required').on('input propertychange', function() {
        var val = $(this).val().trim();
        console.log('input: ', $(this).val().trim());
        if (val !== "") {
          // 这里有值的话，下一个框就应该是必选的
          $(this).parent().next().find(".con-required").attr("required", true);
        } else {
          $(this).parent().next().find(".con-required").attr("required", false);
        }
      })
      $('.select').on('change', function() {
        document.querySelector('.select').setCustomValidity('');
      })
    };
    document.head.appendChild(script);
} else {
  $(document).ready(function() {
    $('.condition-required').on('input propertychange', function() {
      var val = $(this).val().trim();
      console.log('input: ', $(this).val().trim());
      if (val !== "") {
        // 这里有值的话，下一个框就应该是必选的
        $(this).parent().next().find(".con-required").attr("required", true);
      } else {
        $(this).parent().next().find(".con-required").attr("required", false);
      }
    })
    // $('.select').on('change', function() {
    //   document.querySelector('.select').setCustomValidity('');
    // })
  })
}